import React, { useEffect } from 'react';
import AdminLayout from '../components/AdminLayout';
import {
  destroyAdminCharts,
  loadDashboardScript,
  removeDashboardScript,
} from '../utils/adminChartUtils';

const AdminDashboard = () => {
  useEffect(() => {
    let interval;

    const initDashboard = () => {
      if (!window.jQuery) return false;
      requestAnimationFrame(() => {
        loadDashboardScript();
      });
      return true;
    };

    if (initDashboard()) {
      interval = null;
    } else {
      interval = setInterval(() => {
        if (initDashboard()) clearInterval(interval);
      }, 50);
    }

    return () => {
      if (interval) clearInterval(interval);
      destroyAdminCharts();
      removeDashboardScript();
    };
  }, []);

  return (
    <AdminLayout>
      <div className="d-xl-flex justify-content-between align-items-start">
        <h2 className="text-dark font-weight-bold mb-2"> Overview dashboard </h2>
        <div className="d-sm-flex justify-content-xl-between align-items-center mb-2" style={{ boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }}>
          <div className="btn-group bg-white p-3" role="group">
            <button type="button" className="btn btn-link text-light py-0 border-right">7 Days</button>
            <button type="button" className="btn btn-link text-dark py-0 border-right">1 Month</button>
            <button type="button" className="btn btn-link text-light py-0">3 Month</button>
          </div>
          <div className="dropdown ms-0 ml-md-4 mt-2 mt-lg-0">
            <button className="btn bg-white dropdown-toggle p-3 d-flex align-items-center" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i className="mdi mdi-calendar me-1"></i>24 Mar 2019 - 24 Mar 2019
            </button>
            <div className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
              <h6 className="dropdown-header">Select</h6>
              <a className="dropdown-item" href="#">24 Mar 2019 - 24 Mar 2019</a>
              <a className="dropdown-item" href="#">24 Apr 2019 - 24 May 2019</a>
              <a className="dropdown-item" href="#">24 Jun 2019 - 24 Jul 2019</a>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="d-sm-flex justify-content-between align-items-center transaparent-tab-border">
            <ul className="nav nav-tabs tab-transparent" role="tablist">
              <li className="nav-item">
                <a className="nav-link" id="home-tab" data-bs-toggle="tab" href="#" role="tab" aria-selected="true">Users</a>
              </li>
              <li className="nav-item">
                <a className="nav-link active" id="business-tab" data-bs-toggle="tab" href="#business-1" role="tab" aria-selected="false">Business</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" id="performance-tab" data-bs-toggle="tab" href="#" role="tab" aria-selected="false">Performance</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" id="conversion-tab" data-bs-toggle="tab" href="#" role="tab" aria-selected="false">Conversion</a>
              </li>
            </ul>
            <div className="d-md-block d-none">
              <a href="#" className="text-light p-1"><i className="mdi mdi-view-dashboard"></i></a>
              <a href="#" className="text-light p-1"><i className="mdi mdi-dots-vertical"></i></a>
            </div>
          </div>

          <div className="tab-content tab-transparent-content">
            <div className="tab-pane fade show active" id="business-1" role="tabpanel" aria-labelledby="business-tab">

              {/* Stats Cards */}
              <div className="row">
                <div className="col-xl-3 col-lg-6 col-sm-6 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-body text-center">
                      <h5 className="mb-2 text-dark font-weight-normal">Orders</h5>
                      <h2 className="mb-4 text-dark font-weight-bold">932.00</h2>
                      <div className="dashboard-progress dashboard-progress-1 d-flex align-items-center justify-content-center item-parent">
                        <i className="mdi mdi-lightbulb icon-md absolute-center text-dark"></i>
                      </div>
                      <p className="mt-4 mb-0">Completed</p>
                      <h3 className="mb-0 font-weight-bold mt-2 text-dark">5443</h3>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-sm-6 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-body text-center">
                      <h5 className="mb-2 text-dark font-weight-normal">Unique Visitors</h5>
                      <h2 className="mb-4 text-dark font-weight-bold">756,00</h2>
                      <div className="dashboard-progress dashboard-progress-2 d-flex align-items-center justify-content-center item-parent">
                        <i className="mdi mdi-account-circle icon-md absolute-center text-dark"></i>
                      </div>
                      <p className="mt-4 mb-0">Increased since yesterday</p>
                      <h3 className="mb-0 font-weight-bold mt-2 text-dark">50%</h3>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-sm-6 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-body text-center">
                      <h5 className="mb-2 text-dark font-weight-normal">Impressions</h5>
                      <h2 className="mb-4 text-dark font-weight-bold">100,38</h2>
                      <div className="dashboard-progress dashboard-progress-3 d-flex align-items-center justify-content-center item-parent">
                        <i className="mdi mdi-eye icon-md absolute-center text-dark"></i>
                      </div>
                      <p className="mt-4 mb-0">Increased since yesterday</p>
                      <h3 className="mb-0 font-weight-bold mt-2 text-dark">35%</h3>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-sm-6 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-body text-center">
                      <h5 className="mb-2 text-dark font-weight-normal">Followers</h5>
                      <h2 className="mb-4 text-dark font-weight-bold">4250k</h2>
                      <div className="dashboard-progress dashboard-progress-4 d-flex align-items-center justify-content-center item-parent">
                        <i className="mdi mdi-cube icon-md absolute-center text-dark"></i>
                      </div>
                      <p className="mt-4 mb-0">Decreased since yesterday</p>
                      <h3 className="mb-0 font-weight-bold mt-2 text-dark">25%</h3>
                    </div>
                  </div>
                </div>
              </div>

              {/* Charts Row */}
              <div className="row">
                <div className="col-sm-4 grid-margin stretch-card">
                  <div className="card card-danger-gradient">
                    <div className="card-body mb-4">
                      <h4 className="card-title text-white">Account Retention</h4>
                      <canvas id="account-retension"></canvas>
                    </div>
                    <div className="card-body bg-white pt-4">
                      <div className="row pt-4">
                        <div className="col-sm-6">
                          <div className="text-center border-right border-md-0">
                            <h4>Conversion</h4>
                            <h1 className="text-dark font-weight-bold mb-md-3">$306</h1>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="text-center">
                            <h4>Cancellation</h4>
                            <h1 className="text-dark font-weight-bold">$1,520</h1>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-8 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-xl-flex justify-content-between mb-2">
                        <h4 className="card-title">Page views analytics</h4>
                        <div className="graph-custom-legend primary-dot" id="page-view-analytic-legend"></div>
                      </div>
                      <canvas id="page-view-analytic"></canvas>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;
